import { MessageValidation } from "./message-validation";
export class IdValidation {
    constructor() {
        this.message = new MessageValidation('ID inválido');
    }
    validate(request) {
        if (!request.url.id.includes(':') && !request.url.pathParams)
            return true;
        else if (request.url.id.includes(':') && !request.url.pathParams) {
            this.message = new MessageValidation(`Existem variáveis na ID sem valor no PathParams`);
            return false;
        }
        else if (!request.url.id.includes(':') && request.url.pathParams) {
            this.message = new MessageValidation(`Existem valores no PathParams sem variavel correspondente no ID`);
            return false;
        }
        let partesCaminho = request.url.id.split('/');
        if (request.url.pathParams)
            for (let key in request.url.pathParams.data) {
                let keyAchado = false;
                let parteCaminhoAuxiliar = [];
                for (let index = 0; index < partesCaminho.length; index++) {
                    let parte = partesCaminho[index];
                    if (parte.substr(0, 1) == ':' && parte.substr(1) == key) {
                        keyAchado = true;
                        parteCaminhoAuxiliar.push(parte);
                    }
                    else if (parte.substr(0, 1) != ':' || parte.substr(1) != key) {
                        parteCaminhoAuxiliar.push(parte);
                    }
                }
                if (!keyAchado) {
                    this.message = new MessageValidation(`${key} não possui correspondente na url`);
                    return false;
                }
                else if (partesCaminho.length != parteCaminhoAuxiliar.length) {
                    this.message = new MessageValidation(`Existem variáveis na ID sem valor passado`);
                    return false;
                }
            }
        return true;
    }
}
